import _ from 'lodash';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { UPDATE_BASIC_EDIT } from '@/main/store/listEditTypes';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { CRUMB_LABEL_KEY, NAME as name } from '../constants';
import { apiProvider } from '../api';
import { editActions, editMutations } from './types';

interface StrednaklDropdownItem extends DropdownItem {
	ProvozovnaId: number,
}

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [] as DropdownItem[],
		PujcovnaId: [] as DropdownItem[],
		StredNaklOzn: [] as StrednaklDropdownItem[],
		DphSzbOzn: [] as DropdownItem[],
	},
	edit: {
		DphSzbOzn: null as number | null,
		EditDat: null as Date | null,
		EditPracId: null as number | null,
		EditPracIdText: null as string | null,
		Mnozstvi: null as number | null,
		NakladyJdn: null as number | null,
		NakladyJdnProvoz: null as number | null,
		PaNr: null as string | null,
		Pc: null as number | null,
		PcPevna: null as number | null,
		Poznamka2dd: null as string | null,
		PracovnikId: null as number | null,
		PracovnikIdText: null as string | null,
		PracovnikOsobniCis: null as string | null,
		ProvozovnaId: null as number | null,
		PujcovnaId: null as number | null,
		PujcovnapaId: null as number | null,
		Sleva: null as number | null,
		StrednaklOzn: null as number | null,
		StrednaklOznText: null as string | null,
		Text: null as string | null,
		UserMessageList: [],
		VstupDat: null as Date | null,
		VstupPracId: null as number | null,
		VstupPracIdText: null as string | null,
		ZakazkaId: null as number | null,
		ZaznamId: null as number | null,
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {
		UniqCheckPrp: false,
		filterByZakaznik: true,
		filterByZakazka: false,
	},
	extraActions: {
		async [editActions.KONTROLA_ZAPUJCKY]({ state, commit }, params) {
			const resp = await apiProvider.zakazkapaKontrola(params);
			if (!(resp.data.ZakazkaId > 0)) {
				delete resp.data.Zakazkapa.DropDownList;
				delete resp.data.Zakazkapa.Operations;
				delete resp.data.Zakazkapa.ValidationRules;
				commit(UPDATE_BASIC_EDIT, { data: resp.data.Zakazkapa });
			}
			return resp;
		},
		[editActions.PROVOZOVNA_CHANGE]: ({ commit }) => commit(editMutations.PROVOZOVNA_CHANGE),
	},
	extraGetters: {},
	extraMutations: {
		[editMutations.ZAPUJCKY_PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.edit.PracovnikId = data.value;
			state.edit.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.PracovnikOsobniCis = data.osobniCis;

			if (data.value > 0) {
				// TODO: asi odstranit - nenašel jsem v užití ve složce nahradniDily, ale použité u pracovních pozic
				// state.edit.Pracovnik_id_priv = data.value;
				state.edit.ProvozovnaId = data.provozovnaId;
				state.edit.StrednaklOzn = data.strednaklOzn;
			}
		},
		[editMutations.PROVOZOVNA_CHANGE](state) {
			const first = _.find(state.dropdownList.StredNaklOzn, { ProvozovnaId: Number(state.edit.ProvozovnaId) });
			if (first) {
				state.edit.StrednaklOzn = first.Value;
				state.edit.StrednaklOznText = first.Text;
			}
		},
	},
	props: {
		mode: null,
		filter: {
			ZakazkaId: null as number | null,
		},
		ZakaznikId: null as number | null,
		PujcovnapaNr: null as number | null,
		PujcvnaCreateZakazka: false as boolean,
	},
});

export type PujckaRow = {
	PUJCOVNAPA_ID: number | null
	ZAKAZNIK_ID: number | null,
	X_FIRM_PRIJM: string | null,
};
